import Spinner from "../../Components/spinner";
import CustomPagination from "../../helper/Pagination";
import {
 ActionButton,
 ToggleSwitch,
} from "../../helper/ImageFormat";
const ThemeTable = ({
 loading,
 theme,
 currentPage,
 perPage,
 handleEditClick,
 handleDelete,
 handleStatusToggle,
 totalCount,
 totalPages,
 handlePageClick,
}) => {
 return (
  <div className="row ">
   <div className="col-md-12 grid-margin stretch-card">
    <div className="card">
     <div className="card-body">
      <div className="table-responsive">
       <table
        className=" custom-table table table-striped"
        id="myTable"
        style={{ marginTop: "3px" }}
       >
        <thead>
         <tr>
          <th>#</th>
          <th>Name</th>
          <th>Active</th>
          <th>Action</th>
         </tr>
        </thead>
        <tbody>
         {loading ? (
          <tr>
           <td colSpan="8" className="text-center">
            <Spinner />
           </td>
          </tr>
         ) : theme.length > 0 ? (
          theme.map((data, id) => (
           <tr key={data.id}>
            <td>{(currentPage - 1) * perPage + id + 1}</td>
            <td>{data.name}</td>
            <td>
             <ToggleSwitch
              data={data}
              name="isActive"
              checked={data.isActive}
              handleStatusToggle={handleStatusToggle}
              module={"theme"}
             />
            </td>
            <td>
             <ActionButton
              data={data}
              handleEditClick={handleEditClick}
              handleDelete={handleDelete}
              module={"theme"}
             />
            </td>
           </tr>
          ))
         ) : (
          <tr>
           <td colSpan="8" className="text-center">
            <h4>No data available</h4>
           </td>
          </tr>
         )}
        </tbody>
       </table>
      </div>
      {theme?.length > 0 && (
       <div>
        <CustomPagination
         currentPage={currentPage}
         totalPages={totalPages}
         onPageChange={handlePageClick}
         perPage={perPage}
         totalCount={totalCount}
        />
       </div>
      )}
     </div>
    </div>
   </div>
  </div>
 );
};

export default ThemeTable;
